// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--p7FLO","iconHolder":"button-module--icon-holder--2eWzp","loadingIconHolder":"button-module--loading-icon-holder--kLSkw"};